import {
	request1,
	request2
} from './request.js'

export function GetAdminLoginToken(data) {
    return request2({
        url: '/api7/InternalAffairsTeacherWebApi/AdminLogin/GetAdminLoginToken',
        method: 'get',
        params: data,
    })
}
export function loginRoleInformationV2() {
	return request2({
		url: '/api7/SBCenterAdminApi/Admin/LoginRoleInformation',
		method: 'get',
	})
}
export function AdminLoginByRolesId(data) {
	return request2({
		url: '/api7/SBCenterAdminApi/Admin/AdminLoginByRolesId',
		method: 'get',
		params: data,
	})
}
